import { RouteConfig } from 'vue-router';

export default [
  /**
   * 自动还款服务
   */
  {
    path: '/auto-repay',
    meta: {
      title: '自动还款服务',
      customNavBar: true,
    },
    component: () => import('@/views/auto-repay/index.vue'),
  },
  /**
   * 开通还款服务银行卡列表
   */
  {
    path: '/auto-repay/bank-list',
    meta: {
      title: '银行卡绑定',
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/auto-repay/bank-list.vue'),
  },
  /**
   * 自动还款服务结果页
   */
  {
    path: '/auto-repay/result',
    meta: {
      title: '自动还款服务',
      customNavBar: true,
    },
    component: () => import('@/views/auto-repay/result.vue'),
  },
] as RouteConfig[];
